import * as React from "react";

import { ZoomMode, ViewportSyncMode } from "../messaging/commands";
import { PlotTool } from "../plotTools/PlotTool";

export interface Region {
  width: number;
  height: number;
  top: number;
  left: number;
}

interface PlotPanelContext {
  activeTool: PlotTool;
  setActiveTool: (tool: PlotTool) => void;

  viewportSyncMode: ViewportSyncMode;
  setViewportSyncMode: (next: ViewportSyncMode) => void;

  isLegendShown: boolean;
  setIsLegendShown: (next: boolean) => void;

  selectedRegion: Region | null;
  setSelectedRegion: (next: Region | null) => void;

  zoomMode: ZoomMode;
  setZoomMode: (next: ZoomMode) => void;
}

export const PlotPanelContext = React.createContext<PlotPanelContext>({
  activeTool: PlotTool.Move,
  setActiveTool: () => {},

  viewportSyncMode: "x",
  setViewportSyncMode: () => {},

  isLegendShown: true,
  setIsLegendShown: () => {},

  selectedRegion: null,
  setSelectedRegion: () => {},

  zoomMode: "x",
  setZoomMode: () => {},
});
